import colors from '../tokens/colors';

export const informationTextGetolo = {
  textAlign: 'center',
  color: colors.PROFESSIONAL_BLUE,
  colorLight: colors.PROFESSIONAL_LIGHT_BLUE,
  variant: {
    outline: {
      border: `1px solid ${colors.PROFESSIONAL_BLUE}`,
      borderRadius: '8px',
    },
  },
};

export const informationTextDaDirekt = {
  textAlign: 'left',
  color: colors.DA_DIREKT_GRAY_2,
  colorLight: colors.DA_DIREKT_GRAY_2,
  variant: {
    outline: {
      border: `1px solid ${colors.PROFESSIONAL_BLUE}`,
      borderRadius: '4px',
    },
  },
};

export const informationTextDaKaufland = {
  textAlign: 'left',
  color: colors.DA_KAUFLAND_BLACK,
  colorLight: colors.DA_KAUFLAND_BLACK,
  variant: {
    outline: {
      border: `2px solid ${colors.DA_KAUFLAND_GRAY_1}`,
      borderRadius: 0,
    },
  },
};

export const informationTextFressnapf = {
  textAlign: 'center',
  color: colors.FRESSNAPF_TEXT_PRIMARY,
  colorLight: colors.FRESSNAPF_TEXT_PRIMARY,
  variant: {
    outline: {
      border: `2px solid ${colors.DA_KAUFLAND_GRAY_1}`,
      borderRadius: 0,
    },
  },
};
